

































































































































import ViewModel from "@/views/contact/Idea";
export default ViewModel;
